import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import pinia from './store';
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import SearchableSelect from './components/SearchableSelect.vue';
import NumberField from './components/NumberField.vue';
import DatePicker from './components/DatePicker.vue';
import AppTooltip from './components/AppTooltip.vue';
import IconTooltip from './components/IconTooltip.vue';
import LiveIndicator from './components/LiveIndicator.vue';
import ConfirmDialog from './components/ConfirmDialog.vue';
import StatusChip from './components/StatusChip.vue';
import permissionDirective from './directives/permission';

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(vuetify);
app.use(i18n);

// Registered globally - it's the standard dropdown for the whole app, used
// in place of v-select/v-autocomplete on every screen.
app.component('SearchableSelect', SearchableSelect);

// Registered globally - it's the standard numeric input for the whole app,
// used in place of v-text-field type="number" on every screen.
app.component('NumberField', NumberField);

// Registered globally - the standard date/datetime input for the whole
// app, used in place of v-text-field type="date"/"datetime-local" on
// every screen (a calendar popup instead of the browser's native widget).
app.component('DatePicker', DatePicker);

// Registered globally - the standard tooltip wrapper for the whole app
// (custom activator content). Change position/sizing/delay defaults once,
// here, instead of per v-tooltip usage.
app.component('AppTooltip', AppTooltip);

// Registered globally - the standard "small icon with a text hint" tooltip
// (notes icons, info hints, warning markers), built on top of AppTooltip.
app.component('IconTooltip', IconTooltip);

// Registered globally - the standard live-connection status dot + tooltip.
app.component('LiveIndicator', LiveIndicator);

// Registered globally - the standard "are you sure?" delete/confirm dialog
// for the whole app. Change its look/behavior once, here.
app.component('ConfirmDialog', ConfirmDialog);

// Registered globally - the standard active/inactive chip for list and
// detail tables across the whole app.
app.component('StatusChip', StatusChip);

// v-permission="'CUSTOMER:C'" removes the element if the user lacks that
// permission - the standard way to hide create/edit/delete UI app-wide.
app.directive('permission', permissionDirective);

// Wait for the initial route's async component chunk to resolve before
// mounting, so the static #app-loader (see public/index.html) stays visible
// for the whole load instead of Vue mounting to a blank <router-view>
// while that chunk is still being fetched.
router.isReady().then(() => {
  app.mount('#app');
});
